import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/nohome.png'
import _imports_1 from '../assets/homeCheck.png'
import _imports_2 from '../assets/noOrder.png'
import _imports_3 from '../assets/orderCheck.png'
import _imports_4 from '../assets/noMy.png'
import _imports_5 from '../assets/myCheck.png'


const _withScopeId = n => (_pushScopeId("data-v-5e5a204e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "nav" }
const _hoisted_4 = { class: "nav-content" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 0,
  src: _imports_0,
  alt: ""
}
const _hoisted_7 = {
  key: 1,
  src: _imports_1,
  alt: ""
}
const _hoisted_8 = {
  key: 2,
  src: _imports_2,
  alt: ""
}
const _hoisted_9 = {
  key: 3,
  src: _imports_3,
  alt: ""
}
const _hoisted_10 = {
  key: 4,
  src: _imports_4,
  alt: ""
}
const _hoisted_11 = {
  key: 5,
  src: _imports_5,
  alt: ""
}
const _hoisted_12 = { class: "overlay-wrapper" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("加载中...")

import { ref, provide } from "vue";
import router from "@/router";
import { Loading } from "vant";
import { useRoute } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  name: 'index',
  setup(__props) {

const tablist = ref([
  {
    name: "首页",
    checked: true,
    pathName: "HomePage",
  },
  {
    name: "订单",
    checked: false,
    pathName: "OrderPage",
  },
  {
    name: "我的",
    checked: false,
    pathName: "MyPage",
  },
]);
const handleClick = (item: any, index: number) => {
  tablist.value.forEach((tabItem: any) => {
    tabItem.checked = false;
    if (tabItem.name == item.name) {
      tabItem.checked = true;
    }
  });
  router.push({ name: item.pathName });
};
const initData = () => {
  const currentRoute = useRoute();
  tablist.value.forEach((item: any) => {
    if (item.pathName == currentRoute.matched[1]?.name) {
      item.checked = true;
    } else {
      item.checked = false;
    }
  });
};
initData();
const loginVisible = ref(true);

const token = localStorage.getItem("token");
const phone =
  localStorage.getItem("userInfo") &&
  JSON.parse(localStorage.getItem("userInfo")!).phone;
if (!token || !phone) {
  location.replace("/login");
} else {
  loginVisible.value = false;
  // getOederTypes();
}

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_router_view)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tablist.value, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: _normalizeClass(["nav-item", { active: item.checked }]),
              onClick: ($event: any) => (handleClick(item, index))
            }, [
              (index == 0 && !item.checked)
                ? (_openBlock(), _createElementBlock("img", _hoisted_6))
                : _createCommentVNode("", true),
              (index == 0 && item.checked)
                ? (_openBlock(), _createElementBlock("img", _hoisted_7))
                : _createCommentVNode("", true),
              (index == 1 && !item.checked)
                ? (_openBlock(), _createElementBlock("img", _hoisted_8))
                : _createCommentVNode("", true),
              (index == 1 && item.checked)
                ? (_openBlock(), _createElementBlock("img", _hoisted_9))
                : _createCommentVNode("", true),
              (index == 2 && !item.checked)
                ? (_openBlock(), _createElementBlock("img", _hoisted_10))
                : _createCommentVNode("", true),
              (index == 2 && item.checked)
                ? (_openBlock(), _createElementBlock("img", _hoisted_11))
                : _createCommentVNode("", true),
              _createElementVNode("div", null, _toDisplayString(item.name), 1)
            ], 10, _hoisted_5))
          }), 128))
        ])
      ])
    ], 512), [
      [_vShow, !loginVisible.value]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_12, [
      _createVNode(_unref(Loading), {
        color: "#0094ff",
        size: "24px",
        vertical: ""
      }, {
        default: _withCtx(() => [
          _hoisted_13
        ]),
        _: 1
      })
    ], 512), [
      [_vShow, loginVisible.value]
    ])
  ], 64))
}
}

})